import TextArea from "antd/lib/input/TextArea";
import { useState, useRef, useEffect } from "react";
import { auth } from "../../API/Auth";

function ReminderTemplate(props: {
  templateType: string;
  additionalText: string;
  onAdditionalTextChange: any;
  report: any;
  onMainBodyChange?: (body: { html: string; text: string }) => void;
}) {
  const { additionalText, onAdditionalTextChange, report, templateType, onMainBodyChange } = props;
  const {
    org,
    IRBECnotificationReminderTemplateHtml,
    notificationReminderTemplateHtml,
  } = report;

  const template =
    templateType === "IRB/EC"
      ? IRBECnotificationReminderTemplateHtml
      : notificationReminderTemplateHtml;

  // Hooks
  const [editableTemplate, setEditableTemplate] = useState("");
  const [editableDefault, setEditableDefault] = useState("");
  const editableRef = useRef<HTMLDivElement | null>(null);
  const didSetInitialHtml = useRef<boolean>(false);

  const handleTemplateChange = (e: any) => {
    setEditableTemplate(e.currentTarget.innerHTML);
    const html = e.currentTarget.innerHTML;
    const text = e.currentTarget.innerText;
    onMainBodyChange && onMainBodyChange({ html, text });
  };

  const handleDefaultChange = (e: any) => {
    setEditableDefault(e.currentTarget.innerHTML);
    const html = e.currentTarget.innerHTML;
    const text = e.currentTarget.innerText;
    onMainBodyChange && onMainBodyChange({ html, text });
  };

  // When a template exists, set the content once when template/additionalText change
  useEffect(() => {
    if (template && editableRef.current) {
      const computedHtml = template;
      editableRef.current.innerHTML = computedHtml;
      didSetInitialHtml.current = true;
      const html = editableRef.current.innerHTML;
      const text = editableRef.current.innerText;
      onMainBodyChange && onMainBodyChange({ html, text });
    }
  }, [template, additionalText]);

  // On mount, if nothing set, emit default initial content once
  useEffect(() => {
    if (editableRef.current && !didSetInitialHtml.current) {
      const html = editableRef.current.innerHTML;
      const text = editableRef.current.innerText;
      onMainBodyChange && onMainBodyChange({ html, text });
      didSetInitialHtml.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ Case 1: If custom HTML template exists
  if (template) {
    return (
      <div>
        <div
          contentEditable
          suppressContentEditableWarning
          onInput={handleTemplateChange}
          dangerouslySetInnerHTML={{ __html: template }}
          style={{
            border: "1px solid #ddd",
            padding: "1rem",
            borderRadius: "8px",
            minHeight: "200px",
          }}
        />

        {auth.isPermissionExists(["0"]) ? (
          <TextArea
            onChange={(event) => onAdditionalTextChange(event.target.value)}
            style={{ marginTop: "1rem", marginBottom: "1rem" }}
            showCount
            maxLength={2000}
            placeholder="Add any additional information, as required"
          />
        ) : (
          <p>{additionalText}</p>
        )}
      </div>
    );
  }

  // ✅ Case 2: Default Reminder template (editable paragraphs)
  return (
    <div
      contentEditable
      suppressContentEditableWarning
      onInput={handleDefaultChange}
      style={{
        border: "1px solid #ddd",
        padding: "1rem",
        borderRadius: "8px",
        minHeight: "200px",
      }}
    >
      <p>Dear Dr. {"{Name}"},</p>
      <p>
        This is a gentle reminder on the SUSAR notification. Request you to
        kindly provide{" "}
        {templateType === "Acknowledgement"
          ? "your acknowledgement of receipt of the SUSAR notification."
          : "the confirmation of the notification to EC/IRB."}
      </p>

      {auth.isPermissionExists(["0"]) ? (
        <TextArea
          onChange={(event) => onAdditionalTextChange(event.target.value)}
          style={{ marginBottom: "1rem" }}
          showCount
          maxLength={2000}
          placeholder="Add any additional information, as required"
        />
      ) : (
        <p>{additionalText}</p>
      )}

      <p>
        Thank you, and feel free to contact us should you have any questions.
      </p>

      <div>
        <p>Regards,</p>
        <p>Soterius Safety Team</p>
        <p>On behalf of {org}</p>
      </div>
    </div>
  );
}

export default ReminderTemplate;
